// eslint-disable-next-line
import i18n from '../../i18n';
import ERROR_CODES from './ERROR_CODES';

function getErrorMessage(errorCode, error = {}) {
  const { t } = i18n;

  const code = errorCode || error.errorCode;
  const { errorKey } = error;
  const parameters = error.parameters || {};

  // пробуем перевести errorKey (если есть)
  if (errorKey) {
    const translated = t(errorKey, {
      ns: 'errorCodes',
      ...parameters, // подставляем параметры в шаблон
      defaultValue: '',
    });

    if (translated) return translated;
  }

  if (error.detail) return error.detail;

  if (error.title) return error.title;

  // перевод по code
  if (code) {
    return t(code, { ns: 'errorCodes' });
  }

  // неизвестная ошибка
  return t(ERROR_CODES.UNKNOWN_ERROR, { ns: 'errorCodes' });
}

export default getErrorMessage;
